import React, { useEffect } from 'react';
import 'bootstrap/dist/js/bootstrap';
import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';

const Drp_StoreRoom_Simple = (props) => {

    const [List, setList] = React.useState([]);

    const Change = (event) => {
        var index = event.nativeEvent.target.selectedIndex;
        props.onChange(event.target.value, event.nativeEvent.target[index].text)
    }



    const Get = () => {

        setList([]);
        trackPromise(
            fetch(General.ApiRoute() + '/StoreRoom/GetAll', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    var tmp = []
                    for (var i = 0; i < result.length; i++) {
                        if (result[i].isActive == 1) {
                            tmp.push({
                                Row: i + 1,
                                Id: result[i].id,
                                Title: result[i].title,
                                Code: result[i].code,
                                IsActive: result[i].isActive,

                            })

                        }
                    }
                    setList(tmp)
                })
        )


    }

    useEffect(() => {
        Get();
    }, [])

    return (

        <select className={props.className} onChange={Change} value={props.value} disabled={props.disabled}>
            <option value="-1">انتخاب نمایید</option>
            {
                List.map(item => (
                    <option value={item.Id}> {item.Title} ({item.Code})  </option>
                ))
            }

        </select>

    )


}
export default Drp_StoreRoom_Simple;